// import store from '../redux/store';
const states = require('../constants/statesInverted.json');

const validators = {
    email: (str) => new RegExp(/^.+@.+(\.).+/im).test(str),
    phone: (str) => new RegExp(/^[(]?[0-9]{3}[)]?[-\s]{0,3}[0-9]{3}[-\s]{0,3}[0-9]{4,6}$/im).test(str),
    text: (str) => new RegExp('.+').test(str),
    positiveNumber: (num) => num > 0,
    itemDimension: (value) => {
        // Assumes value has already been parsed either into a 2-element array or a float
        if (typeof value === 'object') {
            return value.length === 2;
        } else if (typeof value === 'number') {
            return value > 0;
        }

        return false;
    },
    notNullish: (value) => value !== null && value !== undefined && !isNaN(value),
    addressState: (str) => {
        if (!str || str.constructor !== String) return false;

        return !!states[str];
    },
    addressStreet(str, submitStatus) {
        // const { attempted_pickup_address, attempted_dropoff_address } = store?.getState()?.newOrder?.general || {};
        const { attempted_pickup_address, attempted_dropoff_address } = {};

        const isInvalidPickupStreet =
            submitStatus?.error?.data?.includes?.('pickUp.street') && attempted_pickup_address === str;
        if (isInvalidPickupStreet) return false;

        const isInvalidDropoffStreet =
            submitStatus?.error?.data?.includes?.('dropoff.street') && attempted_dropoff_address === str;
        if (isInvalidDropoffStreet) return false;

        return this.text(str);
    },
};

validators.emailIfNotEmpty = (str) => {
    if (str !== '') {
        return validators.email(str);
    }
    return true;
};

validators.phoneIfNotEmpty = (str) => {
    if (str !== '') {
        return validators.phone(str);
    }
    return true;
};

export default function fieldValidator(expression, typeOrCustomValidation, submitStatus) {
    if (expression === undefined) {
        return false;
    }

    if (typeof typeOrCustomValidation === 'string' && validators[typeOrCustomValidation]) {
        return validators[typeOrCustomValidation](expression, submitStatus);
    } else if (typeof typeOrCustomValidation === 'string') {
        // No matching validator described by type
        // Should throw error, for now just returns false
        return false;
    } else if (typeof typeOrCustomValidation === 'function') {
        return typeOrCustomValidation(expression);
    }

    // ERROR no validator found
    return false;
}
